(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', '$injector', '$log'];

    function notificationInterceptor ($q, $injector, $log) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var alertService = $injector.get('AlertService');
            var alertKey = response.headers('X-formonlineApp-alert');
            if (angular.isString(alertKey)) {
                if (alertService) {
                    alertService.success(alertKey, { param : response.headers('X-formonlineApp-params')});
                } else {
                    $log.error('Could not get \'AlertService\'!');
                }
            }
            return response;
        }
    }
})();
